// Get jQuery from global scope
const $ = window.jQuery;

$(document).ready(function () {
  // Top banner auto-scroll - optimized to batch DOM reads
  function initTopBannerSlider() {
    const $banner = $(".top-banner__slider");
    if (!$banner.length) return;

    const $content = $banner.parent();

    // Batch all DOM reads at once to prevent forced reflows
    let contentWidth, screenWidth;
    requestAnimationFrame(() => {
      contentWidth = $banner.outerWidth();
      screenWidth = $(window).width();

      // Calculate how many clones we need to fill screen + extra for smooth loop
      const clonesNeeded = Math.ceil(screenWidth / contentWidth) + 2;

      // Create multiple clones for seamless infinite scroll
      for (let i = 0; i < clonesNeeded; i++) {
        const $clone = $banner.clone();
        $content.append($clone);
      }

      let position = 0;
      const speed = 0.75; // pixels per frame

      function animate() {
        position -= speed;

        // Reset position for seamless loop
        if (Math.abs(position) >= contentWidth) {
          position = 0;
        }

        $content.css("transform", `translateX(${position}px)`);
        requestAnimationFrame(animate);
      }

      animate();
    });
  }

  // Initialize on load
  initTopBannerSlider();

  var hamburger_open = false;
  $(".hamburger").click(function (event) {
    event.preventDefault();
    $(".mobile-navigation").toggleClass("is-open");
    $("body").toggleClass("menu-open");

    // Update ARIA attributes for accessibility
    var isOpen = $(".mobile-navigation").hasClass("is-open");
    $(this).attr("aria-expanded", isOpen);
    $(this).attr(
      "aria-label",
      isOpen ? "Close navigation menu" : "Open navigation menu",
    );

    if (hamburger_open == false) {
      hamburger_open = true;
      disableScroll();
    } else {
      hamburger_open = false;
      enableScroll();
    }
  });

  $(".mobile-navigation .mobile-navigation__backdrop").click(function () {
    $(".mobile-navigation").removeClass("is-open");
    $("body").removeClass("menu-open");
    $(".hamburger").attr("aria-expanded", "false");
    $(".hamburger").attr("aria-label", "Open navigation menu");
    hamburger_open = false;
    enableScroll();
  });

  var clickable = $(".mobile-navigation__state").attr("data-clickable");
  $(".mobile-navigation li:has(ul)").addClass("has-sub");

  // Declare scroll position variables
  var scrollTop, scrollLeft;

  /* menu open and close on single click - only triggered by caret */
  $(".mobile-navigation__inner .mobile-navigation__caret.trigger-caret").click(
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      var element = $(this).parent("li");

      if (element.hasClass("is-open")) {
        element.removeClass("is-open");
        element.find("li").removeClass("is-open");
        element
          .find("ul")
          .stop(true, false)
          .slideUp(350, function () {
            $(this).css("display", "");
          });
      } else {
        element.addClass("is-open");
        element.children("ul").stop(true, false).slideDown(350);
        element
          .siblings("li")
          .children("ul")
          .stop(true, false)
          .slideUp(350, function () {
            $(this).css("display", "");
          });
        element.siblings("li").removeClass("is-open");
        element.siblings("li").find("li").removeClass("is-open");
        element
          .siblings("li")
          .find("ul")
          .stop(true, false)
          .slideUp(350, function () {
            $(this).css("display", "");
          });
      }
    },
  );

  /* function for disable scroll when menu is opne */
  function disableScroll() {
    // Get the current page scroll position
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    // if any scroll is attempted, set this to the previous value
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }
  /* function for enable scroll when menu is close */
  function enableScroll() {
    window.onscroll = function () {};
  }

  // Handle logged-in header position on scroll
  if ($("body").hasClass("logged-in")) {
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 0) {
        $("body").addClass("scrolled");
      } else {
        $("body").removeClass("scrolled");
      }
    });
  }

  // Add sticky class to header on scroll
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 0) {
      $("header").addClass("sticky");
    } else {
      $("header").removeClass("sticky");
    }
  });

  // Add 'sub-four' class to submenus with fewer than 4 items
  $(".header-content-wrapper nav ul li.menu-item-has-children .sub-menu").each(
    function () {
      var itemCount = $(this).children("li").length;
      if (itemCount < 4) {
        $(this).addClass("sub-four");
      }
    },
  );
});

// Use jQuery to listen for Gravity Forms event
$(document).on("gform_confirmation_loaded", function (event, formId) {
  console.log("gform_confirmation_loaded event fired");
  console.log("Form submitted successfully - Form ID:", formId);
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "gf_form_success",
    form_id: formId,
  });
});
